import React from 'react'

import styled from 'styled-components'

import { Dropdown } from '../Dropdown'

type Props = {
  adminUser?: any
  onSignOut: () => void
}

const Badge = styled.div`
  align-items: center;
  background-color: rgb(116, 201, 71);
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 26px;
  height: 50px;
  justify-content: center;
  margin: 0 10px;
  padding: 10px;
  text-align: center;
  user-select: none;
  width: 50px;
`

const AdminUserBadge = (props: Props): JSX.Element => {
  const { adminUser, onSignOut } = props

  if (!adminUser) return null

  const renderTrigger = (dropdownProps: any) => (
    <Badge onClick={dropdownProps.onClick}>
      {adminUser.firstName.charAt(0).toUpperCase()}
      {adminUser.lastName.charAt(0).toUpperCase()}
    </Badge>
  )

  return (
    <Dropdown
      align="right"
      items={[
        {
          handler: onSignOut,
          title: 'Logout',
        },
      ]}
      renderTrigger={renderTrigger}
    />
  )
}

export { AdminUserBadge }
